import { useEffect } from "react";
import { FaUser, FaSave, FaKey } from "react-icons/fa";
import { USERS_CONSTANTS } from "../_MODULES/_API";
import { AUTH_CONSTANTS } from "../../../Public/_Auth/_MODULES/_API";
import { PageHeader } from "../../../../../_CORE/APP/Templates/_UI/PageHeader/_index";
import { AppButton } from "../../../../../_CORE/APP/Templates/_UI/Button/_index";
import { Card } from "../../../../../_CORE/APP/Templates/_UI/Kit/_index";
import { FormGrid, FieldInput, useForm } from "../../../../../_CORE/APP/Templates/_UI/Form/_index";
import { useApiActionMutation } from "../../../../../_CORE/APP/Hooks/Hooks/_Actions/_useApiActionMutation";
import { useUserAuthenticated } from "../../../../../_CORE/APP/Hooks/Contexts/_Auth/userAuthenticatedContext";
import { ViewLayout } from "../../../../_UI/ViewLayout";
import "../_UI/_Styles/Profile.css";

export const ProfileViewMain = () => {

    const { useDataUserAuth, refreshUserAuth } = useUserAuthenticated();

    const USER = useDataUserAuth?.data ?? {};

    const { actionMutate: onMutateProfile, useActionApiIsLoading: IS_SAVING_PROFILE } = useApiActionMutation({
        isToastError: true, isToastSuccess: true, minTimeMutate: 300,
    });

    const { actionMutate: onMutatePassword, useActionApiIsLoading: IS_SAVING_PASSWORD } = useApiActionMutation({
        isToastError: true, isToastSuccess: true, minTimeMutate: 300,
    });

    const FORM_PROFILE = useForm({
        initialValues: { name: "", email: "" },

        schema: { name: { required: true, minLength: 2 }, email: { required: true, email: true } },

        onSubmit: async (values) => {

            const RESPONSE = await onMutateProfile({
                method: "PATCH", endpoint: USERS_CONSTANTS.UPDATE, id: "me",
                data: { name: values.name.trim(), email: values.email.trim() },
            });

            if (RESPONSE.success) await refreshUserAuth();
            else FORM_PROFILE.applyApiError(RESPONSE);
        },
    });

    const FORM_PASSWORD = useForm({
        initialValues: { currentPassword: "", newPassword: "", repeatPassword: "" },

        schema: {
            currentPassword: { required: true, maxLength: 200 },
            newPassword: { required: true, minLength: 10, maxLength: 200 },
            repeatPassword: { required: true, sameAs: { field: "newPassword", message: "Las contraseñas no coinciden" } },
        },

        onSubmit: async (values) => {

            const RESPONSE = await onMutatePassword({
                method: "POST", endpoint: AUTH_CONSTANTS.CHANGE_PASSWORD,
                data: { currentPassword: values.currentPassword, newPassword: values.newPassword },
            });

            if (RESPONSE.success) FORM_PASSWORD.reset();
            else FORM_PASSWORD.applyApiError(RESPONSE);
        },
    });

    useEffect(() => {
        const NAME = String(USER.name ?? "").trim();
        const EMAIL = String(USER.email ?? "").trim();
        const IS_EMAIL_USED_AS_NAME = !!NAME && !!EMAIL && NAME.toLowerCase() === EMAIL.toLowerCase();

        FORM_PROFILE.setValues({
            name: IS_EMAIL_USED_AS_NAME ? "" : NAME,
            email: EMAIL,
        });
    }, [USER.id]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <ViewLayout
            header={
                <PageHeader title="Mi perfil" description="Sos el único usuario del sistema." icon={<FaUser />} />
            } >

            <div className="LStudio__app_profile_grid">

                <Card title="Datos de acceso">

                    <FormGrid columns={1}>

                        <FieldInput {...FORM_PROFILE.field("name")} label="Nombre" />

                        <FieldInput {...FORM_PROFILE.field("email")} type="email" label="Correo electrónico" />

                    </FormGrid>

                    <AppButton icon={<FaSave />} isLoading={IS_SAVING_PROFILE} onClick={FORM_PROFILE.onSubmit}>
                        Guardar cambios
                    </AppButton>

                </Card>

                <Card title="Cambiar contraseña">

                    <FormGrid columns={1}>

                        <FieldInput {...FORM_PASSWORD.field("currentPassword")} type="password" label="Contraseña actual" />

                        <FieldInput {...FORM_PASSWORD.field("newPassword")} type="password" label="Contraseña nueva" />

                        <FieldInput {...FORM_PASSWORD.field("repeatPassword")} type="password" label="Repetir la nueva" />

                    </FormGrid>

                    <AppButton icon={<FaKey />} isLoading={IS_SAVING_PASSWORD} onClick={FORM_PASSWORD.onSubmit}>
                        Actualizar contraseña
                    </AppButton>

                </Card>

            </div>
        </ViewLayout>
    );
};
